import {FC} from "react";
import { makeStyles, Tabs } from "@material-ui/core";
import { scroller } from "react-scroll";
import Tab from "@material-ui/core/Tab";
import { Colors } from "../../helpers/theme";
import { TabsMobileBulletsProps } from "../../interfaces";


const useStyles = makeStyles((theme) => ({
  tabIcon: {
    "& .MuiTab-root": {
      minWidth: "15px",
      minHeight: "15px",
      padding: "0px",
      "&:not(last-child)": {
        marginRight: theme.spacing(1),
      },
      "&.MuiTab-textColorSecondary.Mui-selected": {
        background: Colors.green,
      },
    },
    "& .MuiTabs-flexContainer": {
      justifyContent: "center",
    },
  },
}));

const MobileButtets:FC<TabsMobileBulletsProps> = (props) => {
  const classes = useStyles();
  const items = props.bullets;
  const scrollTop = () => {
    scroller.scrollTo(props.scroll.current.getAttribute("id"), {
      duration: 1500,
      delay: 0,
      smooth: "easeInOutQuart",
      offset: -100,
    });
  };

  return (
    <>
      <Tabs
        onClick={scrollTop}
        value={props.value}
        textColor="secondary"
        indicatorColor="secondary"
        onChange={props.handleChange}
        className={classes.tabIcon}
      >
        {items.map((item) => (
          <Tab key={item} />
        ))}
      </Tabs>
    </>
  );
};

export default MobileButtets;
